import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./containers/Layout";
import { ClinicProvider } from "./context/ClinicContext";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Dashboard from "./pages/Dashboard";
import RapidEntry from "./pages/RapidEntry";
import PatientList from "./pages/PatientList";
import UserProfile from "./pages/UserProfile";
import ClinicProfile from "./pages/ClinicProfile";
import EMRSettings from "./pages/EMRSettings";
import DoctorList from "./pages/DoctorList";
import GeneratePrescription from "../prescription/pages/generatePrescription";
import GeneratePrescriptionAi from "../prescription/pages/generatePrescriptionAi";
import Billing from "../prescription/pages/billing";
import { isAuthenticated } from "./utils/commonUtils";
import Prescriptions from "./pages/Prescriptions";
import Billinglist from "./pages/Billing";
import Report from "./pages/Report";
import Payment from "./pages/Payment";
import PatientProfilePage from "./pages/PatientProfilePage";
import BillingForm from "./pages/BillingForm";
import Settings from "./pages/Setting";
import Service from "./pages/service";
import ForgotPassword from "./pages/ForgotPassword";
const ProtectedRoute = ({ element, path }) => {
  return isAuthenticated() ? (
    <Layout>{element}</Layout>
  ) : (
    <Navigate to="/clinic/login" state={{ from: path }} />
  );
};

const routes = [
  { path: "/dashboard", element: <ProtectedRoute element={<Dashboard />} /> },
  { path: "/patient", element: <ProtectedRoute element={<PatientList />} /> },
  {
    path: "/patientProfile",
    element: <ProtectedRoute element={<PatientProfilePage />} />,
  },
  { path: "/rapid-entry", element: <ProtectedRoute element={<RapidEntry />} /> },
  {
    path: "/userProfile",
    element: <ProtectedRoute element={<UserProfile />} />,
  },
  {
    path: "/clinicProfile",
    element: <ProtectedRoute element={<ClinicProfile />} />,
  },
  {
    path: "/EMRSettings",
    element: <ProtectedRoute element={<EMRSettings />} />,
  },
  { path: "/doctor", element: <ProtectedRoute element={<DoctorList />} /> },
  {
    path: "/generatePrescription",
    element: <ProtectedRoute element={<GeneratePrescription />} />,
  },
  {
    path: "/generatePrescriptionAi",
    element: <ProtectedRoute element={<GeneratePrescriptionAi />} />,
  },
  { path: "/billing", element: <ProtectedRoute element={<BillingForm />} /> },
  {
    path: "/prescriptions",
    element: <ProtectedRoute element={<Prescriptions />} />,
  },
  {
    path: "/billinglist",
    element: <ProtectedRoute element={<Billinglist />} />,
  },
  {
    path: "/report",
    element: <ProtectedRoute element={<Report />} />,
  },
  {
    path: "/payment",
    element: <ProtectedRoute element={<Payment />} />,
  },
  {
    path: "/Setting",
    element: <ProtectedRoute element={<Settings />} />,
  },
  {
    path: "/Service",
    element: <ProtectedRoute element={<Service />} />,
  },
];

export function ClinicRoutes() {
  return (
    <ClinicProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route
          path="*"
          element={<Navigate to="/404" state={{ from: "clinic" }} />}
        />
      </Routes>
    </ClinicProvider>
  );
}
